const upcoming = [
    {
        id: "1",
        title: "A webinar on Big Data Engineering",
        link: "https://i.ibb.co/kmLbpWt/Big-Data-Engineering.png",
        descLong: "",
        descShort: "A webinar by Mr. Mario Rozario on Big Data Engineering",
        date: "28th January 2021",
        timing: "11:00-12:00 PM",
        registerLink: "https://forms.gle/kirTFbwU8Npn4DDn8"
    }
];

export default upcoming;
